var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5401 16.5642C12.5401 16.39 12.6042 16.2158 12.7417 16.0783L17.8201 11L12.7417 5.92165C12.4759 5.65582 12.4759 5.21582 12.7417 4.94999C13.0076 4.68415 13.4476 4.68415 13.7134 4.94999L19.2776 10.5142C19.5434 10.78 19.5434 11.22 19.2776 11.4858L13.7134 17.05C13.4476 17.3158 13.0076 17.3158 12.7417 17.05C12.6042 16.9217 12.5401 16.7383 12.5401 16.5642Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.52086 11C2.52086 10.6242 2.83253 10.3125 3.20836 10.3125L18.6359 10.3125C19.0117 10.3125 19.3234 10.6242 19.3234 11C19.3234 11.3758 19.0117 11.6875 18.6359 11.6875L3.20836 11.6875C2.83253 11.6875 2.52086 11.3758 2.52086 11Z",
    fill: "#292D32"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineArrow);
export default __webpack_public_path__ + "static/media/line_arrow.33e383e4bbf50b4bcce4b3a7c427231d.svg";
export { ForwardRef as ReactComponent };